@if(translations){
<div class="purple-fit-layout-main-container tab-menu">
  <div class="purple-fit-layout-main-container-internal">

    <div class="purple-fit-select-broker-container {{((breakSvc.breakPointDevice()) != 'desktop')?'':'desktop'}}">
      <div class="purple-fit-select-broker-image-container">
        <img class="purple-fit-select-broker-image" src="https://purple-fit-broker.pages.dev/logo.png" alt="PurpleFit">
      </div>

      <p class="purple-fit-select-broker-title">{{translations.get(lan)?.get("broker_page_title")}}</p>
      <p class="purple-fit-select-broker-subtitle">{{translations.get(lan)?.get("broker_page_subtitle")}}</p>

      <div class="purple-fit-select-broker-internal-container">
        <purple-pin pinType="number" [pinNumber]="6" [pinValue]="pinValue"
          (onPinCodesChange)="pinCodeChange($event)"></purple-pin>
      </div>

      @if((breakSvc.breakPointDevice()) == 'desktop'){
      <div class="purple-fit-select-broker-button-container">
        <purple-simple-button class="purple-fit-select-broker-button" (click)="setEndpoint()" [isLoading]="isLoading"
          [buttonText]="translations.get(lan)?.get('broker_page_btn_text')??''" [isDisabled]="buttonDisabled()"
          buttonType="primary">
        </purple-simple-button>
      </div>
      }
    </div>


  </div>
</div>

@if((breakSvc.breakPointDevice()) != 'desktop'){
<div class="purple-fit-broker-footer">
  <div class="purple-fit-broker-footer-button-container">
    <purple-simple-button class="purple-fit-footer-button" (click)="setEndpoint()" [isLoading]="isLoading"
      [buttonText]="translations.get(lan)?.get('broker_page_btn_text')??''" [isDisabled]="buttonDisabled()"
      buttonType="primary">
    </purple-simple-button>
  </div>
</div>
}
}